(function () {
  if (customElements.get('op-parecido-buscador')) return;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0,
    }).format(value);
  }

  // Guarda de presentación, no de datos: un metafield mal cargado en
  // Shopify puede traer un % de descuento sin sentido (ej. -27891%). El
  // backend nunca inventa el número, pero tampoco hay que mostrárselo tal
  // cual a un cliente — si no es un % creíble, se omite el badge en vez de
  // confundir (no se "corrige" el dato, solo no se pinta si es absurdo).
  function isCredibleDiscount(pct) {
    return typeof pct === 'number' && pct > 0 && pct <= 90;
  }

  // Tile cuadrado de fondo claro para la foto de producto: la mayoría de
  // las fotos de perfume vienen con fondo blanco/transparente y flotaban
  // sueltas sobre el fondo oscuro del modal — este marco las ancla igual
  // que una vidriera, en vez de verse como un recorte pegado.
  function imageTile(product, size) {
    if (!product.image) return '';
    return (
      '<div class="op-parecido-modal__thumb" style="--op-thumb-size:' + size + 'px">' +
      '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
      '</div>'
    );
  }

  function priceRow(product) {
    return (
      '<div class="op-parecido-modal__price-row">' +
      '<span class="op-parecido__side-price op-parecido__side-price--alt">' +
      (product.compare_at_price
        ? '<s>' + escapeHtml(formatPrice(product.compare_at_price)) + '</s> '
        : '') +
      escapeHtml(formatPrice(product.price)) +
      '</span>' +
      (isCredibleDiscount(product.discount_pct)
        ? '<span class="op-parecido__badge">−' + escapeHtml(product.discount_pct) + '%</span>'
        : '') +
      '</div>'
    );
  }

  class OpParecidoBuscador extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-op-form]');
      this.input = this.querySelector('[data-op-input]');
      this.dialog = this.querySelector('[data-op-modal]');
      this.body = this.querySelector('[data-op-modal-body]');
      this.closeBtn = this.querySelector('[data-op-modal-close]');

      this.modalEnabled = this.dataset.modalEnabled === 'true';
      this.apiEndpoint = this.dataset.apiEndpoint || '';
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';

      // Sin <dialog> nativo o sin endpoint configurado: se deja el submit
      // normal (GET a "Destino del buscador" — Opción A / fallback).
      if (
        !this.modalEnabled ||
        !this.apiEndpoint ||
        !this.dialog ||
        typeof this.dialog.showModal !== 'function'
      ) {
        return;
      }

      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.dialog.close());
      }
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    onSubmit(event) {
      var query = (this.input.value || '').trim();
      if (!query) return;
      event.preventDefault();

      this.dialog.showModal();
      this.renderLoading();
      this.search(query);
    }

    renderLoading() {
      this.body.innerHTML =
        '<p class="op-parecido-modal__status">' + escapeHtml(this.dataset.loadingMessage) + '</p>';
    }

    renderEmpty() {
      this.body.innerHTML =
        '<p class="op-parecido-modal__status">' + escapeHtml(this.dataset.noResultsMessage) + '</p>';
    }

    renderError() {
      this.body.innerHTML =
        '<p class="op-parecido-modal__status">' + escapeHtml(this.dataset.errorMessage) + '</p>';
    }

    renderOriginal(original) {
      var product = original.product;

      return (
        '<div class="op-parecido__card op-parecido-modal__card op-parecido-modal__card--original">' +
        '<div class="op-parecido__side op-parecido__side--alt">' +
        '<div class="op-parecido__side-label op-parecido__side-label--alt">' +
        escapeHtml(this.dataset.originalFoundLabel) +
        '</div>' +
        imageTile(product, 132) +
        '<div class="op-parecido__side-name">' + escapeHtml(product.title) + '</div>' +
        priceRow(product) +
        '</div>' +
        '<div class="op-parecido-modal__actions">' +
        '<a class="op-parecido-modal__view-btn" href="' + escapeHtml(product.url) + '">' +
        escapeHtml(this.dataset.viewProductLabel) +
        '</a>' +
        '</div>' +
        '</div>'
      );
    }

    renderBrandProductCard(product) {
      var cartFormHtml = product.variant_id
        ? '<form is="product-form" action="' + escapeHtml(this.cartAddUrl) + '" method="post" class="op-parecido-modal__cart-form">' +
          '<input type="hidden" name="id" value="' + escapeHtml(product.variant_id) + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="op-parecido-modal__add-btn">' +
          escapeHtml(this.dataset.addToCartLabel) +
          '</button>' +
          '</form>'
        : '';

      return (
        '<div class="op-parecido__card op-parecido-modal__card op-parecido-modal__card--brand">' +
        '<div class="op-parecido-modal__brand-main">' +
        imageTile(product, 68) +
        '<div class="op-parecido-modal__brand-info">' +
        '<div class="op-parecido__side-name">' + escapeHtml(product.title) + '</div>' +
        priceRow(product) +
        '</div>' +
        '</div>' +
        '<div class="op-parecido-modal__actions">' +
        '<a class="op-parecido-modal__view-btn" href="' + escapeHtml(product.url) + '">' +
        escapeHtml(this.dataset.viewProductLabel) +
        '</a>' +
        cartFormHtml +
        '</div>' +
        '</div>'
      );
    }

    renderMatchCard(match) {
      var product = match.product;
      var isApproximate = match.match_type === 'approximate';

      var notasHtml =
        product.notes && product.notes.length
          ? '<div class="op-parecido-modal__notas">Notas: ' + escapeHtml(product.notes.join(', ')) + '</div>'
          : '';

      var caracteristicasHtml =
        product.characteristics && product.characteristics.length
          ? '<div class="op-parecido-modal__notas">' + escapeHtml(product.characteristics.join(' · ')) + '</div>'
          : '';

      var cartFormHtml = product.variant_id
        ? '<form is="product-form" action="' + escapeHtml(this.cartAddUrl) + '" method="post" class="op-parecido-modal__cart-form">' +
          '<input type="hidden" name="id" value="' + escapeHtml(product.variant_id) + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="op-parecido-modal__add-btn">' +
          escapeHtml(this.dataset.addToCartLabel) +
          '</button>' +
          '</form>'
        : '';

      var avisoHtml = isApproximate
        ? '<p class="op-parecido-modal__aviso">' + escapeHtml(this.dataset.approximateMessage) + '</p>'
        : '';

      return (
        avisoHtml +
        '<div class="op-parecido__card op-parecido-modal__card">' +
        '<div class="op-parecido__side">' +
        '<div class="op-parecido__side-label">' +
        escapeHtml(this.dataset.originalLabel) +
        '</div>' +
        '<div class="op-parecido__side-name">' + escapeHtml(match.original_name) + '</div>' +
        '</div>' +
        '<div class="op-parecido__arrow" aria-hidden="true">→</div>' +
        '<div class="op-parecido__side op-parecido__side--alt">' +
        '<div class="op-parecido__side-label op-parecido__side-label--alt">' +
        escapeHtml(isApproximate ? this.dataset.approximateAltLabel : this.dataset.altLabel) +
        '</div>' +
        imageTile(product, 132) +
        '<div class="op-parecido__side-name">' + escapeHtml(product.title) + '</div>' +
        priceRow(product) +
        notasHtml +
        caracteristicasHtml +
        '</div>' +
        '<div class="op-parecido-modal__actions">' +
        '<a class="op-parecido-modal__view-btn" href="' + escapeHtml(product.url) + '">' +
        escapeHtml(this.dataset.viewProductLabel) +
        '</a>' +
        cartFormHtml +
        '</div>' +
        '</div>'
      );
    }

    renderResults(data) {
      var original = data.original;
      var matches = data.matches || [];
      var brandProducts = data.brand_products || [];

      // Regla de cero alucinación: sin original, sin matches y sin
      // productos reales de la marca -> mensaje explícito, nunca se
      // inventa ni se fuerza un resultado.
      if (!original && matches.length === 0 && brandProducts.length === 0) {
        this.renderEmpty();
        return;
      }

      var html = '';
      if (original) html += this.renderOriginal(original);
      // Puede haber varias alternativas reales (ej. 2+ productos curados
      // como "Parecido a" del mismo perfume) — se muestran todas, ya
      // vienen ordenadas por el backend (parecido de aroma, stock,
      // precio), nunca se elige una sola arbitrariamente.
      matches.forEach((match) => {
        html += this.renderMatchCard(match);
      });

      // Resultado secundario: no hay alternativa/dupe confirmada, pero la
      // tienda vende productos reales de la marca que el cliente buscó
      // (útil sobre todo cuando escribió la marca con errores/typos y no
      // apuntaba a un perfume puntual) — nunca reemplaza a original/matches,
      // solo se muestra cuando esos dos vinieron vacíos.
      if (!original && matches.length === 0 && brandProducts.length > 0) {
        html +=
          '<p class="op-parecido-modal__aviso">' +
          escapeHtml(this.dataset.brandProductsMessage) +
          '</p>' +
          '<div class="op-parecido-modal__brand-grid">' +
          brandProducts.map((product) => this.renderBrandProductCard(product)).join('') +
          '</div>';
      }

      this.body.innerHTML = html;

      // El <form is="product-form"> se auto-registra (customElements
      // upgrade) y ya sabe hablar con el carrito/drawer del tema — acá
      // solo cerramos ESTE modal al enviarlo, el drawer de carrito del
      // tema toma el control solo (ver assets/cart.js, evento
      // "cart:refresh"). Puede haber más de un form de carrito (varias
      // alternativas o varios brand_products) — hay que engancharlos todos,
      // no solo el primero.
      this.body.querySelectorAll('.op-parecido-modal__cart-form').forEach((cartForm) => {
        cartForm.addEventListener('submit', () => this.dialog.close());
      });
    }

    search(query) {
      var url = this.apiEndpoint + '?q=' + encodeURIComponent(query) + '&limit=3';
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('API respondió ' + res.status);
          return res.json();
        })
        .then((data) => this.renderResults(data))
        .catch((err) => {
          this.renderError();
          // eslint-disable-next-line no-console
          console.error('op-parecido-buscador:', err);
        });
    }
  }

  customElements.define('op-parecido-buscador', OpParecidoBuscador);
})();
